import { Vue, Component, Ref } from 'vue-property-decorator'
import ScientificAnalysisSearchPanel from './components/scientific-analysis-search-panel/scientific-analysis-search-panel.vue'
import ScientificAnalysisSearchPanelComponent from './components/scientific-analysis-search-panel/scientific-analysis-search-panel'
import ScientificAnalysisNoresultsPanel from './components/scientific-analysis-noresults-panel/scientific-analysis-noresults-panel.vue'
import ScientificAnalysisResultsPanel from './components/scientific-analysis-results-panel/scientific-analysis-results-panel.vue'
import ScientificAnalysisResultsPanelComponent from './components/scientific-analysis-results-panel/scientific-analysis-results-panel'
import ScientificAnalysisFilterPanel from './components/scientific-analysis-filter-panel/scientific-analysis-filter-panel.vue'
import ScientificAnalysisFilterPanelComponent from './components/scientific-analysis-filter-panel/scientific-analysis-filter-panel'
import { initialScientificAnalysisModuleState, ScientificAnalysisModuleState } from './scientific-analysis-module.models'
import { SCIENTIFIC_ANALYSIS_NONE_SELECTED_FILTER } from '@/modules/scientific-analysis-module/components/scientific-analysis-search-panel/scientific-analysis-search-panel.models'
import { ScientificAnalysis, ScientificAnalysisEntityFilters, ScientificAnalysisFilter } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'

@Component({
    components: { ScientificAnalysisSearchPanel, ScientificAnalysisFilterPanel, ScientificAnalysisNoresultsPanel, ScientificAnalysisResultsPanel }
})
export default class ScientificAnalysisModule extends Vue {
    private state: ScientificAnalysisModuleState;

    @Ref('searchPanel') readonly searchPanel!: ScientificAnalysisSearchPanelComponent
    @Ref('filterPanel') readonly filterPanel!: ScientificAnalysisFilterPanelComponent
    @Ref('resultsPanel') readonly resultsPanel!: ScientificAnalysisResultsPanelComponent

    constructor() {
        super()
        this.state = initialScientificAnalysisModuleState()
    }

    get _renderFilter():boolean {
        return !!this.state.selectedFilter
    }

    get _renderResults():boolean {
        return this.state.renderResults
    }

    get _showResults():boolean {
        return !this._renderFilter
    }

    _onFilterSelected(entityFilters: ScientificAnalysisEntityFilters, filter: ScientificAnalysisFilter, filterIndex: number):void {
        if (entityFilters && filter && filterIndex !== SCIENTIFIC_ANALYSIS_NONE_SELECTED_FILTER) {
            this.state.selectedFilter = {
                entityFilters,
                filter,
                filterIndex
            }
            if (this.filterPanel) {
                this.filterPanel.focus()
            }
        } else {
            this.state.selectedFilter = null
        }
    }

    async _onRemoveSelectedFilter():Promise<void> {
        if (this.state.selectedFilter) {
            this.searchPanel.removeFilter(this.state.selectedFilter.entityFilters, this.state.selectedFilter.filterIndex)
        }
    }

    _onFilterPanelClosed():void {
        this.state.selectedFilter = null
        this.searchPanel.unselectAllFilters()
    }

    _onSearch(_scientificAnalysis: ScientificAnalysis):void {
        this._onFilterPanelClosed()
        if (this._renderResults && this.resultsPanel) {
            this.resultsPanel.search()
        }
        this.state.renderResults = true
    }

    _onSearchModification(): void {
        if (this._renderResults && this.resultsPanel) {
            this.resultsPanel.setDirty()
        }
    }

    _onTemplateLoad(template: ScientificAnalysis):void {
        this.state.scientificAnalysis = template
        this._onSearchModification()
    }
}
